import * as uuid from "uuid";

export function generatePrefixedId(prefix: string): string {
  const MAX_TOTAL_LENGTH = 128;
  const UUID_LENGTH = 36;
  const SEPARATOR_LENGTH = 1; // "_"
  const MAX_PREFIX_LENGTH = MAX_TOTAL_LENGTH - SEPARATOR_LENGTH - UUID_LENGTH;

  const id = uuid.v4().replace(/-/g, "_");
  const safePrefix = prefix.length > MAX_PREFIX_LENGTH ? prefix.slice(0, MAX_PREFIX_LENGTH) : prefix;
  return `${safePrefix}_${id}`;
}
